import MailsTable from '@/components/admin/mails/MailsTable';
import UserEmailOptOutCard from '@/components/admin/users/UserEmailOptOutCard';
import type { User } from '@/models';

interface UserDetailPageTabMailsProps {
  user: User;
  onUserUpdated: (user: User) => void;
}

export default function UserDetailPageTabMails({ user, onUserUpdated }: UserDetailPageTabMailsProps) {
  return (
    <div className="space-y-8">
      <UserEmailOptOutCard user={user} onUserUpdated={onUserUpdated} />

      <div>
        <MailsTable userId={user.id} />
      </div>
    </div>
  );
}
